import { Button, Grid, Stack, Typography } from "@mui/material";
import { ReactComponent as MoveAllRowLeft } from "../../../../../../assets/icons/move-all-row-left.svg";
import { ReactComponent as MoveAllRowRight } from "../../../../../../assets/icons/move-all-rows-right.svg";
import { ReactComponent as MoveRowLeft } from "../../../../../../assets/icons/move-row-left.svg";
import { ReactComponent as MoveRowRight } from "../../../../../../assets/icons/move-row-right.svg";
import "../../../../../../css/medint.css";
import { useContext, useEffect, useMemo, useState } from "react";
import { MedintDataContext } from "../../../../Context/MedintContextWrapper";
import { StyledDataGrid } from "../../../../../AppointmentManagement/AppointmentManagementDetail/AppointmentManagementDetail";
import { GridColDef, GridSelectionModel } from "@mui/x-data-grid";
import { medpgm, medpgmp } from "../../../../../../networking";
import MedintAgendaPrestazioneNotesModal from "./MedintAgendaPrestazioneNotesModal";
import GestioneCombinateModal from "./GestioneCombinateModal";
import VincoliPrenotabilitaModal from "./VincoliPrenotabilitaModal";

const MedintBookingAgenda = ({
  onlyFirstTable = false,
  onlyAdditionalTables = false,
  loading = false,
  setLoading = () => {},
  dataGeneral = [],
  setDataGeneral = () => [],
  selectedAgenda = [],
  setSelectedAgenda = () => {},
  selectedErogate = [],
  setSelectedErogate = () => [],
  selectedAbbinate = [],
  setSelectedAbbinate = () => [],
  dataPrestazioniErogabiliAgenda = [],
  setDataPrestazioniErogabili = () => [],
  dataPrestazioniAbbinate = [],
  setPrestazioniAbbinate = () => {},
  fethDataMedico,
}: {
  onlyFirstTable?: boolean;
  loading?: boolean;
  setLoading?: React.Dispatch<React.SetStateAction<boolean>>;
  onlyAdditionalTables?: boolean;
  selectedAgenda?: any;
  fethDataMedico: () => Promise<void>;
  setSelectedAgenda?: React.Dispatch<React.SetStateAction<any>>;
  selectedErogate?: GridSelectionModel;
  setSelectedErogate?: React.Dispatch<React.SetStateAction<any>>;
  selectedAbbinate?: GridSelectionModel;
  setSelectedAbbinate?: React.Dispatch<React.SetStateAction<any>>;
  dataGeneral?: any;
  setDataGeneral?: React.Dispatch<React.SetStateAction<any>>;
  dataPrestazioniErogabiliAgenda?: any;
  setDataPrestazioniErogabili?: any;
  dataPrestazioniAbbinate?: any;
  setPrestazioniAbbinate?: React.Dispatch<
    React.SetStateAction<{ [key: string]: any }[]>
  >;
}) => {
  const context = useContext(MedintDataContext);

  const [openModal, setOpenModal] = useState<any>(false);
  const [openGestioneCombinate, setOpenGestioneCombinate] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any | null>(null);
  const [openVincoliPrenotabilita, setOpenVincoliPrenotabilita] =
    useState(false);

  const erogabiliMemo = useMemo(
    () =>
      dataPrestazioniErogabiliAgenda?.filter(
        (item: any) =>
          !selectedAgenda?.prestazioniAbbinate?.some(
            (abbinata: any) =>
              abbinata?.prestazione === item?.prestazione &&
              abbinata?.tipologia === item?.tipologia,
          ),
      ) ?? [],
    [selectedAgenda, selectedAgenda?.prestazioniAbbinate],
  );

  const abbinabiliMemo = useMemo(
    () => selectedAgenda?.prestazioniAbbinate ?? [],
    [selectedAgenda, selectedAgenda?.prestazioniAbbinate],
  );

  const tabCols: GridColDef[] = [
    { field: "id" },
    { field: "specialita", headerName: "Specialità", flex: 1 },
    {
      field: "descrizione",
      headerName: "Descrizione",
      flex: 1,
    },
    {
      field: "prestazione",
      headerName: "Prestazione",
      flex: 1,
    },
    {
      field: "tipologia",
      headerName: "Tipologia",
      flex: 1,
    },
  ];

  const updateAgenda = async (idMedpgm: string) => {
    try {
      const response = await medpgm({
        crud: "r",
        idMedpgm: idMedpgm,
      });

      if (response?.data?.esito === "OK") {
        console.log(response.data.dati);
        console.log({ dataGeneral });

        const prestazioniConId =
          response.data?.dati?.[0]?.prestazioniabbinate?.map(
            (value: any, index: number) => ({
              id: index,
              idMedpgmp: value.IDMEDPGMP,
              idMedpgm: value.IDMEDPGM,
              idAnapre: value.IDANAPRE,
              specialita: value.CODICESPECIALITA,
              prestazione: value.CODICEPRESTAZIONE,
              descrizione: value.DESCRPRESTAZIONE,
              tipologia: value.DESCRTIPOAGENDA,
              codiceAgenda: value.CODICETIPOAGENDA,
            }),
          ) ?? [];

        setDataGeneral((prev: any[]) =>
          prev.map((item) =>
            item.idMedpgm === idMedpgm
              ? {
                  ...item,
                  prestazioniAbbinate: prestazioniConId,
                }
              : item,
          ),
        );

        // obblogatorio per aggiornare la vista dei valori su griglia
        setSelectedAgenda((prev: any) =>
          prev?.idMedpgm === idMedpgm
            ? {
                ...prev,
                prestazioniAbbinate: prestazioniConId,
              }
            : prev,
        );
      }
    } catch (error) {
      console.error(
        `Errore durante il recupero dell'agenda idMedpgm ${idMedpgm}:`,
        error,
      );
    } finally {
      setLoading(false);
    }
  };

  const moveAllRight = async () => {
    try {
      setLoading(true);
      await Promise.all(
        erogabiliMemo.map((element: any) =>
          medpgmp({
            crud: "c",
            idMedpgm: selectedAgenda.idMedpgm ?? "",
            idAnapre: element.idAnapre ?? "",
            codiceTpgpre: element.codTpgpre ?? "",
          }),
        ),
      );
      await updateAgenda(selectedAgenda.idMedpgm);
    } catch (error) {
      console.error("Errore durante l'invio:", error);
    } finally {
      setSelectedErogate(null);
    }
  };

  const moveToRight = async () => {
    try {
      setLoading(true);
      await Promise.all(
        selectedErogate.map((element: any) =>
          medpgmp({
            crud: "c",
            idMedpgm: selectedAgenda.idMedpgm ?? "",
            idAnapre: element.idAnapre ?? "",
            codiceTpgpre: element.codTpgpre ?? "",
          }),
        ),
      );
      await updateAgenda(selectedAgenda.idMedpgm);
    } catch (error) {
      console.error("Errore durante l'invio:", error);
    } finally {
      setSelectedErogate(null);
    }
  };

  const moveToLeft = async () => {
    setLoading(true);

    try {
      await Promise.all(
        selectedAbbinate.map((element: any) =>
          medpgmp({
            crud: "d",
            idMedpgmp: element.idMedpgmp ?? "",
          }),
        ),
      );
      await updateAgenda(selectedAgenda.idMedpgm);
    } catch (error) {
      console.error("Errore durante spostamento abbinate:", error);
    } finally {
      setSelectedAbbinate(null);
    }
  };

  const moveAllLeft = async () => {
    setLoading(true);
    try {
      await Promise.all(
        abbinabiliMemo.map((element: any) =>
          medpgmp({
            crud: "d",
            idMedpgmp: element.idMedpgmp ?? "",
          }),
        ),
      );
      await updateAgenda(selectedAgenda.idMedpgm);
    } catch (error) {
      console.error("Errore durante l'invio:", error);
    } finally {
      setSelectedAbbinate(null);
    }
  };

  useEffect(() => {
    console.log(selectedAgenda.prestazioniAbbinate);
    console.log({ selectedAgenda });
  }, [selectedAgenda]);

  return (
    <>
      {openModal && (
        <MedintAgendaPrestazioneNotesModal
          open={openModal}
          onClose={() => setOpenModal(false)}
          selectedRow={selectedRow}
        />
      )}
      {openGestioneCombinate && (
        <GestioneCombinateModal
          open={openGestioneCombinate}
          onClose={() => setOpenGestioneCombinate(false)}
          selectedRow={selectedRow}
        />
      )}

      {openVincoliPrenotabilita && (
        <VincoliPrenotabilitaModal
          open={openVincoliPrenotabilita}
          onClose={() => setOpenVincoliPrenotabilita(false)}
          selectedRow={selectedRow}
        />
      )}
      <Grid
        container
        sx={{ display: "flex", width: "100%", justifyContent: "space-evenly" }}
      >
        {/* Colonna di sinistra */}
        <Grid item xs={5} width={"100%"}>
          <Typography
            sx={{
              color: "rgba(0, 0, 0, 0.60)",
              fontWeight: "bold",
              mb: 2,
            }}
          >
            Prestazioni Erogabili
          </Typography>
          <StyledDataGrid
            rows={selectedAgenda <= 0 ? [] : erogabiliMemo}
            disableColumnSelector={selectedAgenda <= 0 ? true : false}
            disableSelectionOnClick={selectedAgenda <= 0 ? true : false}
            checkboxSelection
            onSelectionModelChange={(ids: GridSelectionModel) => {
              const selectedRows = dataPrestazioniErogabiliAgenda?.filter(
                (r: any) => ids?.includes(r?.id),
              );
              console.log(selectedRows);
              console.log(dataGeneral);
              setSelectedErogate(selectedRows);
            }}
            columns={tabCols}
            getRowId={(r) => r.id}
            sortingOrder={["desc", "asc", null]}
            columnVisibilityModel={{
              id: false,
            }}
            sx={{
              height: 200,
              '& .MuiDataGrid-columnHeaders [data-field="__orderBySelected__"] .MuiDataGrid-sortIcon':
                {
                  display: "none",
                },
              "& .MuiDataGrid-row:hover": {
                cursor: "pointer",
              },
              "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
                outline: "none",
              },
            }}
          />
        </Grid>

        <Grid
          item
          xs={1}
          sx={{
            display: "flex",
            width: "100%",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            mt: 3,
          }}
        >
          <Button
            variant="containedMedintCustom"
            disabled={selectedAgenda <= 0 ? true : false}
            onClick={moveAllRight}
            sx={{
              mt: 1,
              backgroundColor: "rgba(229, 229, 229, 0.30) !important",
              border: "1px solid rgba(204, 204, 204, 0.80)",
              borderRadius: "4px",
            }}
          >
            <MoveAllRowRight />{" "}
          </Button>
          <Button
            variant="containedMedintCustom"
            disabled={selectedAgenda <= 0 ? true : false}
            onClick={moveToRight}
            sx={{
              mt: 1,
              backgroundColor: "rgba(229, 229, 229, 0.30) !important",
              border: "1px solid rgba(204, 204, 204, 0.80)",
              borderRadius: "4px",
            }}
          >
            <MoveRowRight />
          </Button>
          <Button
            variant="containedMedintCustom"
            disabled={selectedAgenda <= 0 ? true : false}
            onClick={moveToLeft}
            sx={{
              mt: 1,
              backgroundColor: "rgba(229, 229, 229, 0.30) !important",
              border: "1px solid rgba(204, 204, 204, 0.80)",
              borderRadius: "4px",
            }}
          >
            <MoveRowLeft />
          </Button>
          <Button
            variant="containedMedintCustom"
            disabled={selectedAgenda <= 0 ? true : false}
            onClick={moveAllLeft}
            sx={{
              mt: 1,
              backgroundColor: "rgba(229, 229, 229, 0.30) !important",
              border: "1px solid rgba(204, 204, 204, 0.80)",
              borderRadius: "4px",
            }}
          >
            <MoveAllRowLeft />{" "}
          </Button>
        </Grid>

        {/* Colonna di destra */}
        <Grid item xs={5} width={"100%"}>
          <Typography
            sx={{
              color: "rgba(0, 0, 0, 0.60)",
              fontWeight: "bold",
              mb: 2,
            }}
          >
            Prestazioni abbinate all'agenda
          </Typography>
          <StyledDataGrid
            key={selectedAgenda?.idMedpgm}
            rows={abbinabiliMemo}
            columns={tabCols}
            getRowId={(r) => r.id}
            checkboxSelection
            onSelectionModelChange={(ids: GridSelectionModel) => {
              const selectedRows = selectedAgenda?.prestazioniAbbinate?.filter(
                (r: any) => ids?.includes(r?.id),
              );
              console.log(selectedRows);
              setSelectedAbbinate(selectedRows);
              setSelectedRow(selectedRows?.[0] ?? null);
            }}
            sortingOrder={["desc", "asc", null]}
            columnVisibilityModel={{
              id: false,
            }}
            sx={{
              height: 200,
              '& .MuiDataGrid-columnHeaders [data-field="__orderBySelected__"] .MuiDataGrid-sortIcon':
                {
                  display: "none",
                },
              "& .MuiDataGrid-row:hover": {
                cursor: "pointer",
              },
              "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
                outline: "none",
              },
            }}
          />
        </Grid>
        <Grid item xs={12} display={"flex"} justifyContent={"flex-end"} mt={2}>
          <Stack direction={"row"} gap={2}>
            <Button
              variant="outlinedCustom"
              onClick={() => {
                if (!selectedRow) return;
                setOpenModal(true);
              }}
              disabled={!selectedAbbinate || selectedAbbinate.length !== 1}
            >
              Note Prestazione/Agenda
            </Button>
            <Button
              variant="outlinedCustom"
              onClick={() => {
                if (!selectedRow) return;
                setOpenGestioneCombinate(true);
              }}
              disabled={!selectedAbbinate || selectedAbbinate.length !== 1}
            >
              Gestione Combinate
            </Button>
            <Button
              variant="outlinedCustom"
              onClick={() => {
                if (!selectedRow) return;
                setOpenVincoliPrenotabilita(true);
              }}
              disabled={!selectedAbbinate || selectedAbbinate.length !== 1}
            >
              Vincoli Prenotabilità
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </>
  );
};

export default MedintBookingAgenda;
